var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center space-x-1" },
    [
      _vm._l(5, function (star) {
        return _c(
          "button",
          {
            key: star,
            staticClass: "focus:outline-none",
            class: {
              "cursor-pointer": !_vm.disabled,
              "cursor-not-allowed opacity-50": _vm.disabled,
            },
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.setRating(star)
              },
              mouseover: function ($event) {
                _vm.hoverRating = star
              },
              mouseleave: function ($event) {
                _vm.hoverRating = 0
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "w-6 h-6 transition-colors duration-150",
                class: {
                  "text-yellow-400":
                    _vm.hoverRating >= star ||
                    (!_vm.hoverRating && _vm.value >= star),
                  "text-gray-300":
                    (_vm.hoverRating && _vm.hoverRating < star) ||
                    (!_vm.hoverRating && _vm.value < star),
                },
                attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
                  },
                }),
              ]
            ),
          ]
        )
      }),
      _c("span", { staticClass: "ml-2 text-sm text-gray-600" }, [
        _vm._v(" " + _vm._s(_vm.ratingText) + " "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }